import Vue from 'vue'
import Vuex from 'vuex'
import { event } from 'vue-analytics'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

//TYPES
const types = {
	TOGGLE_NAV: 'TOGGLE_NAV',
	TOGGLE_SCHED: 'TOGGLE_SCHED',
	TOGGLE_STREAM: 'TOGGLE_STREAM',
  TOGGLE_QUOTES: 'TOGGLE_QUOTES'
}

//INITIAL STATE
const state = {
	navOpen: false,
  schedOpen: false,
  schedOpenedOnMount: false,
	broadcastLink: '',
	activeVideo: null,
	streamOpen: false,
  quotesOpen: false,
  soundOn: false,
  isMobile: false
}

//GETTERS
const getters = {
	navOpen: state => state.navOpen,
  schedOpen: state => state.schedOpen,
  schedOpenedOnMount: state => state.schedOpenedOnMount,
	streamOpen: state => state.streamOpen,
  quotesOpen: state => state.quotesOpen,
	broadcastLink: state => state.broadcastLink,
  activeVideo: state => state.activeVideo,
  soundOn: state => state.soundOn,
  isMobile: state => state.isMobile
}

//MUTATIONS
const mutations = {
  [types.TOGGLE_NAV] (state) {
    state.navOpen = !state.navOpen
  },
  [types.TOGGLE_SCHED] (state) {
    state.schedOpen = !state.schedOpen
    state.schedOpenedOnMount = true;
  },
  [types.TOGGLE_STREAM] (state) {
    state.streamOpen = !state.streamOpen
  },
  [types.TOGGLE_QUOTES] (state) {
    state.quotesOpen = !state.quotesOpen
  },
  updateBroadcastLink (state, payload) {
    state.broadcastLink = payload
  },
  updateActiveVideo (state, payload) {
    state.activeVideo = payload
  },
  toggleSound (state) {
    state.soundOn = !state.soundOn;
  },
  openNav (state, data) {
    state.navOpen = data;
  },
  setIsMobile (state, data) {
    state.isMobile = data;
  }
}

//ACTIONS
const actions = {
	toggleNav ({ commit, state }) {
    commit(types.TOGGLE_NAV)
    event('Navigation', 'toggle')
  },
  toggleQuotes ({ commit, state }) {
    commit(types.TOGGLE_QUOTES)
    event('Quotes', 'toggle')
  },
  toggleSched ({ commit, state }) {
    commit(types.TOGGLE_SCHED)
    event('RBSchedule', 'toggle')
  },
  toggleStream ({ commit, state }) {
    commit(types.TOGGLE_STREAM)
    event('Livestream', 'toggle')
  },
  updateBroadcastLink ({ commit }, payload) {
	  commit('updateBroadcastLink', payload)
  },
  updateActiveVideo ({ commit }, payload) {
	  commit('updateActiveVideo', payload)
  }
}


//EXPORT
export default new Vuex.Store({
	state,
	actions,
	mutations,
	getters,
	strict: debug
})